/* eslint-disable no-unused-expressions */
import * as React from "react";
import { createRoot } from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";

// integrating sentry
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import store from "./redux/store";
import theme from "./theme";

// eslint-disable-next-line import/no-named-as-default
import AppRouter from "./config/router";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./styles.css";

const SENTRY_DSN_URL = process.env.REACT_APP_SENTRY_DSN;
const SENTRY_ENV = process.env.REACT_APP_SENTRY_ENV;

if (process.env.NODE_ENV && process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: SENTRY_DSN_URL, // Project DSN value
    integrations: [new Integrations.BrowserTracing(), new Sentry.Replay()],
    tracesSampleRate: 0.2,
    environment: SENTRY_ENV,
  });
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRouter />
    </ThemeProvider>
  </Provider>
);
